import { Modal } from "antd";
import { useState } from "react";
import { Api } from "../../common/Api";

export const useAppVersions = () => {
  const [appVersions, setAppVersions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState<any>({});
  const [openEditDlg, setOpenEditDlg] = useState(false);
  const [saving, setSaving] = useState(false);

  const androidList = appVersions.filter((x) => x.type === "android");
  const iosList = appVersions.filter((x) => x.type === "ios");

  const appVersion = {
    iosVersion: iosList?.[0]?.version || "1.1.3",
    iosForceUpdate: iosList?.[0]?.forceUpdate || false,
    androidVersion: androidList?.[0]?.version || "1.1.3",
    androidForceUpdate: androidList?.[0]?.forceUpdate || false,
  };

  const refresh = () => {
    setLoading(true);
    Api.setting
      .appVersions()
      .then((res) => {
        setAppVersions(res.data.appVersions);
      })
      .finally(() => setLoading(false));
  };

  const delAppVersion = (id) => {
    Modal.confirm({
      title: "Are you sure delete this version?",
      onOk: () => {
        Api.setting.delAppVersion(id).then((res) => {
          refresh();
        });
      },
    });
  };

  const add = (type) => {
    setModel({ type, version: "", forceUpdate: false, notes: "" });
    setOpenEditDlg(true);
  };

  const save = (values) => {
    setSaving(true);
    return Api.setting
      .addAppVersion({ ...values, type: model.type })
      .then((res) => {
        setOpenEditDlg(false);
        refresh();
      })
      .finally(() => setSaving(false));
  };

  const check = (version) => {
    return Api.setting.checkVersion({ version, type: model.type }).then((res) => res.data.checkAppVersion);
  };

  return {
    appVersion,
    androidList,
    iosList,
    loading,
    refresh,
    add,
    openEditDlg,
    setOpenEditDlg,
    saving,
    delAppVersion,
    save,
    model,
    setModel,
    check,
  };
};
